import "./utils/console";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Comprehensive ResizeObserver error suppression
const resizeObserverErrHandler = () => {
  const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
  const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
  if (resizeObserverErr) {
    resizeObserverErr.setAttribute('style', 'display: none');
  }
  if (resizeObserverErrDiv) {
    resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
};

// Suppress ResizeObserver errors (common during animations, non-breaking)
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded' ||
      e.message.includes('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    resizeObserverErrHandler();
    return false;
  }
});

// Watch for the error overlay appearing
const observer = new MutationObserver(() => {
  resizeObserverErrHandler();
});
observer.observe(document.body, { childList: true, subtree: true });

// Suppress browser extension errors (React DevTools, etc.)
window.addEventListener('error', (event) => {
  // Ignore "disconnected port" errors from browser extensions
  if (event.message && event.message.includes('disconnected port')) {
    event.preventDefault();
    return;
  }
  // Ignore Chrome extension errors
  if (event.filename && event.filename.includes('chrome-extension://')) {
    event.preventDefault();
    return;
  }
});

// Suppress unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', (event) => {
  // Ignore extension-related rejections
  if (event.reason && event.reason.message && 
      (event.reason.message.includes('disconnected port') || 
       event.reason.message.includes('Extension context'))) {
    event.preventDefault();
    return;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
